var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2472 29.705C59.2472 37.7701 55.9674 46.3438 50.6857 51.6256C45.4039 56.9074 36.826 59.9959 28.765 59.9959C20.704 59.9959 12.4883 56.5493 7.20651 51.2635C1.92472 45.9776 0 37.7701 0 29.705C0 21.6399 2.71414 14.2299 8 8.94405C13.2859 3.65819 20.6958 0 28.7609 0C36.826 0 43.1699 4.72838 48.4558 10.0142C53.7416 15.3001 59.2472 21.6439 59.2472 29.705Z",
    fill: "#FF9FD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1967 31.5978L34.9523 26.6713H30.2255V23.4744C30.2255 22.1266 30.8859 20.8128 33.003 20.8128H35.152V16.6186C35.152 16.6186 33.2017 16.2857 31.337 16.2857C27.4441 16.2857 24.8996 18.6451 24.8996 22.9165V26.6713H20.5723V31.5978H24.8996V43.5072C25.7674 43.6434 26.6565 43.7143 27.5626 43.7143C28.4686 43.7143 29.3577 43.6434 30.2255 43.5072V31.5978H34.1967Z",
    fill: "#1E1010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.2472,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7d7b93d648e8eb143fbfbdfe1c16076.svg";
export { ForwardRef as ReactComponent };